import FastModal from 'components/FastModal';
import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import {parseMessage} from 'lib/stringHelper';
import {FmlxRadioButton} from 'fmlx-common-ui';
import {useDispatch, useSelector} from 'react-redux';
import {hideModal} from 'stores/actions/modalStateAction';
import {getRealTimeErrorCodeNumber} from 'stores/selectors/modalStateSelectors';
import './modalReturnTipsConfirmation.scss';
import {useState} from 'react';
import {ManualReteachTipsStatus} from 'constants/dataEnum';
import {setStatusTipsAfterManualReteach} from './returnTipsBusiness';

function ModalReturnTipsConfirmation() {
  const dispatch = useDispatch();
  const [tipsStatus, setTipsStatus] = useState(ManualReteachTipsStatus.PUT_TO_CADDY);
  const errorNumber = useSelector(getRealTimeErrorCodeNumber);
  const isShown = true;

  const header = parseMessage('plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.title');
  const content = (
    <div className="return-tips-content">
      <div className="content-title">
        <FormattedHTMLMessage id="plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.content.title" />
      </div>
      <div className="content-radio">
        <FmlxRadioButton
          selectedIndex={Object.values(ManualReteachTipsStatus).indexOf(tipsStatus)}
          size="sm"
          items={[
            {
              content: parseMessage(
                'plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.content.choose1',
              ),
            },
            {
              content: parseMessage(
                'plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.content.choose2',
              ),
            },
          ]}
          direction="row"
          onChange={({index}) => setTipsStatus(Object.values(ManualReteachTipsStatus)[index])}
        />
      </div>
    </div>
  );

  const button = [
    {
      className: 'btn-lg',
      style: 'primary',
      text: parseMessage('plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.confirm'),
      handlerClick: () => dispatch(setStatusTipsAfterManualReteach(tipsStatus)),
    },
    {
      className: 'btn-lg',
      style: 'secondary',
      text: parseMessage('plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.cancel'),
      handlerClick: () => {
        dispatch(hideModal());
      },
    },
  ];

  return (
    <FastModal show={isShown} header={header} content={content} errorCodeNumber={errorNumber} btnAction={button} />
  );
}

export default ModalReturnTipsConfirmation;
